import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import PartnersComponent from "../../components/2Layout/PartnersComponent";

const About = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      {/* Page Header */}
      <section className="bg-light py-5">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div
                className="d-inline-flex justify-content-center align-items-center bg-primary-custom rounded-circle mb-3"
                style={{ width: "60px", height: "60px" }}
              >
                <i className="fas fa-building fa-lg text-white"></i>
              </div>
              <h1 class="fw-bold text-primary-custom mb-3">
                {t("about_us.title")}
              </h1>
              <p className="lead mb-2">{t("about_us.description1")}</p>
              <p className="text-muted">{t("about_us.description2")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h1 className="fw-bold text-primary-custom mb-3">
                {t("our_story.title")}
              </h1>
              <p className="text-muted">{t("our_story.description")}</p>
            </div>
          </div>

          <div className="row">
            {[
              {
                title: t("our_story.points.0.title"),
                text: t("our_story.points.0.text"),
              },
              {
                title: t("our_story.points.1.title"),
                text: t("our_story.points.1.text"),
              },
              {
                title: t("our_story.points.2.title"),
                text: t("our_story.points.2.text"),
              },
              {
                title: t("our_story.points.3.title"),
                text: t("our_story.points.3.text"),
              },
            ].map((story, idx) => (
              <div className="col-md-6 mb-4" key={idx}>
                <div
                  className="card h-100 border-0 shadow-sm"
                  data-aos="fade-up"
                >
                  <div className="card-body p-4">
                    <h5 className="fw-bold mb-3">{story.title}</h5>
                    <p className="mb-0">{story.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission and Vision */}
      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h1 className="fw-bold text-primary-custom mb-3">
                {t("mission_vision.title")}
              </h1>
              <p className="text-muted">{t("mission_vision.description")}</p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="card border-0 shadow-sm h-100" data-aos="zoom-in">
                <div className="card-body p-4 text-center">
                  <div className="icon-box bg-primary-custom-light text-primary-custom mx-auto mb-4">
                    <i className="fas fa-bullseye fa-2x"></i>
                  </div>
                  <h4 className="fw-bold mb-3">
                    {t("mission_vision.mission.title")}
                  </h4>
                  <p>{t("mission_vision.mission.text")}</p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card border-0 shadow-sm h-100" data-aos="zoom-in">
                <div className="card-body p-4 text-center">
                  <div className="icon-box bg-primary-custom-light text-primary-custom mx-auto mb-4">
                    <i className="fas fa-eye fa-2x"></i>
                  </div>
                  <h4 className="fw-bold mb-3">
                    {t("mission_vision.vision.title")}
                  </h4>
                  <p>{t("mission_vision.vision.text")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/* <section className="py-5">
        <div className="container py-4">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="fw-bold text-primary-custom mb-3">
                {t("team.title")}
              </h2>
              <p className="text-muted">{t("team.description")}</p>
            </div>
          </div>

          <div className="row g-4">
            {[
              {
                name: t("team.members.0.name"),
                role: t("team.members.0.role"),
                img: "/website/assets-v2/team/team1.jpg",
              },
              {
                name: t("team.members.1.name"),
                role: t("team.members.1.role"),
                img: "/website/assets-v2/team/team2.jpg",
              },
              {
                name: t("team.members.2.name"),
                role: t("team.members.2.role"),
                img: "/website/assets-v2/team/team3.jpg",
              },
              {
                name: t("team.members.3.name"),
                role: t("team.members.3.role"),
                img: "/website/assets-v2/team/team4.jpg",
              },
            ].map((member, idx) => (
              <div className="col-lg-3 col-md-6" key={idx}>
                <div
                  className="card team-card border-0 shadow-sm h-100"
                  data-aos="fade-up"
                >
                  <div className="team-img-container">
                    <img
                      src={member.img}
                      className="card-img-top"
                      alt="عضو الفريق"
                    />
                  </div>
                  <div className="card-body text-center">
                    <h5 className="card-title fw-bold mb-1">{member.name}</h5>
                    <p className="text-muted small mb-3">{member.role}</p>
                    <div className="social-links">
                      <a href="#" className="text-muted me-2">
                        <i className="fab fa-linkedin"></i>
                      </a>
                      <a href="#" className="text-muted me-2">
                        <i className="fab fa-twitter"></i>
                      </a>
                      <a href="#" className="text-muted">
                        <i className="fas fa-envelope"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="py-5 bg-primary-custom text-white" data-aos="fade-up">
        <div className="container py-4">
          <div className="row g-4 text-center">
            <div className="col-md-3 col-6">
              <div className="p-3">
                <h2 className="fw-bold mb-0 counter">93+</h2>
                <p className="mb-0">{t("stats.speakers")}</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="p-3">
                <h2 className="fw-bold mb-0 counter">5+</h2>
                <p className="mb-0">{t("stats.events")}</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="p-3">
                <h2 className="fw-bold mb-0 counter">2+</h2>
                <p className="mb-0">{t("stats.countries")}</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="p-3">
                <h2 className="fw-bold mb-0 counter">95%</h2>
                <p className="mb-0">{t("stats.satisfaction")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PartnersComponent />

      <div className="container py-5"style={{ minHeight: "300px" }}>
        <div className="row justify-content-center mb-4">
          <div className="col-md-12 text-center">
            <h1 className="fw-bold text-primary-custom mb-3">
              {t("sponsors")}
            </h1>

            <div className="row align-items-center py-5 gx-6 justify-content-center">
              {[
                {
                  name: "شركة مفيد",
                  href: "https://mufeed.com/ar/",
                  img: "/assets-v2/images/sponsors/mufeed.jpg",
                },
                {
                  name: "شركة السويلم",
                  href: "https://swilem.com/",
                  img: "/assets-v2/images/sponsors/sy.png",
                },
              ].map((partner, index) => (
                <div
                  key={index}
                  className="col-4 col-md-2"
                  data-aos="zoom-in"
                  data-aos-delay={index * 100}
                >
                  <div
                    className="rounded-circle bg-white p-1 mx-auto partner-logo"
                    style={{
                      width: "90px",
                      height: "90px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid rgba(255,255,255,0.15)",
                    }}
                  >
                    <a
                      href={partner.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-block"
                    >
                      <img
                        src={partner.img}
                        alt={partner.name}
                        className="img-fluid rounded-circle"
                        style={{
                          maxWidth: "200px",
                          maxHeight: "200px",
                          // filter: "grayscale(100%)",
                        }}
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
